import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import {
  Grid,
  Header,
  List,
  Icon,
  Message,
  Accordion,
} from "semantic-ui-react";
import allStores from "../data/all-stores.js";

import {
  RangeIds,
  RangeUuids,
  RangeIdsByLocation,
  StockIds,
  ShowDate,
  ImageList,
} from "./ranging-utils.js";

const RangeResults = () => {
  const results = useSelector((state) => state.rangeSearch);

  const [dotcomList, setDotcomList] = useState([]);
  const [tsaysList, setTsaysList] = useState([]);
  const [whooshList, setWhooshList] = useState([]);
  const [allStoresList, setAllStoresList] = useState([]);
  const [countryCode, setCountryCode] = useState("GB");
  const [aldiPriceMatch, setAldiPriceMatch] = useState(false);
  const [headline, setHeadline] = useState("");
  const [images, setImages] = useState();
  const [hfss, setHfss] = useState();
  const [hfssStatus, setHfssStatus] = useState();
  const [activeIndex, setActiveIndex] = useState(-1);

  const getHfss = (data) => {
    let concern = 0,
      good = 0;
    if (data.calcNutrition && data.calcNutrition.calcNutrients) {
      const { calcNutrients } = data.calcNutrition;
      calcNutrients.forEach((nutrient) => {
        if (nutrient.name.indexOf("kJ") !== -1) {
          concern += Math.floor(parseInt(nutrient.valuePer100) / 335);
        }
        if (nutrient.name.indexOf("sugars") !== -1) {
          concern += Math.floor(parseInt(nutrient.valuePer100) / 4.5);
        }
        if (nutrient.name.indexOf("saturates") !== -1) {
          concern += Math.floor(parseInt(nutrient.valuePer100));
        }
        if (nutrient.name.indexOf("Salt") !== -1) {
          concern += Math.floor(parseInt((nutrient.valuePer100 * 1000) / 90));
        }
        if (nutrient.name.indexOf("Fibre") !== -1) {
          const fibre = Math.floor(parseInt(nutrient.valuePer100) / 0.9);
          good += fibre > 5 ? 5 : fibre;
        }
        if (nutrient.name.indexOf("Protein") !== -1) {
          const protein = Math.floor(parseInt(nutrient.valuePer100) / 1.6);
          good += protein > 5 ? 5 : protein;
        }
      });
    }
    console.log(concern, good);
  };

  useEffect(() => {
    if (results)
      setCountryCode(results.result.priceData.currency === "GBP" ? "GB" : "IE");
  }, [results]);

  useEffect(() => {
    if (results) {
      //const { location } = results.result.rangeData.content[0].data[0];
      const location = results.result.rangeData;
      if (location.length > 0) {
        let stores = { dotcom: [], says: [], whoosh: [], allStores: [] };
        location.forEach((loc) => {
          let obj = _.find(allStores, (store) => {
            //return loc.uuid === store.uuid;
            return loc.locationUUID === store.uuid;
          });
          if (obj) {
            if (obj.services.delivery) stores.dotcom.push(obj);
            if (obj.services.says) stores.says.push(obj);
            if (obj.services.whoosh) stores.whoosh.push(obj);
          }
        });
        setDotcomList(stores.dotcom);
        setTsaysList(stores.says);
        setWhooshList(stores.whoosh);
        setAllStoresList(location);
      }
    }
  }, [results]);

  useEffect(() => {
    if (results) {
      const { country } = results.result.productData;
      const countryItem = country.find((item) => item.code === countryCode);
      setAldiPriceMatch(countryItem.isAldiPriceMatch);
    }
  }, [results, countryCode]);

  useEffect(() => {
    if (results) {
      const { availabilities } = results.result.stockData;
      //const productTitle = results.result.productData.description;
      const rangeTotal = dotcomList.length;
      const tsaysTotal = tsaysList.length;
      const whooshTotal = whooshList.length;
      const availableTotal = availabilities.length;
      const inStock = availabilities.reduce((previousValue, currentValue) => {
        let sum = previousValue;
        if (currentValue.availabilityStatus === "IN_STOCK") sum++;
        return sum;
      }, 0);
      setHeadline(
        `available in ${availableTotal} dotcom stores
        (in stock in ${inStock}),
        ranged in ${rangeTotal} dotcom stores${
          countryCode === "GB"
            ? `, 
            ranged in ${tsaysTotal} SAYS stores, 
            ranged in ${whooshTotal} Whoosh stores`
            : ""
        }`,
      );
    }
  }, [dotcomList, results, tsaysList, whooshList, countryCode]);

  useEffect(() => {
    if (results) {
      const { digitalContent } = results.result.productData;
      if (digitalContent) {
        const filteredImages = digitalContent.filter((item) => {
          return item.mimeType === "image/jpeg";
        });
        setImages(filteredImages);
      }
    }
  }, [results]);

  useEffect(() => {
    if (results) {
      let { productData } = results.result;
      let { hfssProgram } = productData;
      console.log(hfssProgram, productData);
      if (
        !hfssProgram &&
        (productData.productCharacteristics.isDrink ||
          productData.productCharacteristics.isFood)
      ) {
        hfssProgram = getHfss(productData);
      }
      console.log("HFSS", getHfss(productData), hfssProgram);
      setHfss(hfssProgram);
      if (hfssProgram) setHfssStatus(hfssProgram.indicator === "HFSS");
    }
  }, [results]);

  const HfssList = () => {
    return Object.keys(hfss).map((key) => {
      return (
        <List.Item as="li" key={key}>
          {key}: {hfss[key]}
        </List.Item>
      );
    });
  };

  const handleAccordianIndex = (event, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  return (
    <Grid padded>
      {results && (
        <Grid.Row>
          <Grid.Column computer={6} tablet={8} mobile={16}>
            <Header as="h3" className="pre-line">
              {results.result.productData.description} - <br />
              {headline}
            </Header>
            {images && <ImageList images={images} />}
            <List as="ul">
              <List.Item as="li">
                Price: {results.result.priceData.currency}{" "}
                {results.result.priceData.sellingPrice}
              </List.Item>
              {results.result.promoData.length > 0 && (
                <>
                  <List.Item as="li">
                    Offer: {results.result.promoData[0].headline}
                  </List.Item>
                  <List.Item as="li">
                    Start date:{" "}
                    <ShowDate
                      date={results.result.promoData[0].startDateTime}
                    />
                  </List.Item>
                  <List.Item as="li">
                    End date:{" "}
                    <ShowDate date={results.result.promoData[0].endDateTime} />
                  </List.Item>
                </>
              )}
              <List.Item as="li">
                Aldi Price Match:{" "}
                {aldiPriceMatch ? (
                  <Icon name="check" color="green" />
                ) : (
                  <Icon name="close" color="red" />
                )}
              </List.Item>
              <List.Item as="li">
                Brand: {results.result.productData.brand}
              </List.Item>
              <List.Item as="li">
                TPNB: {results.result.productData.tpnb}
              </List.Item>
              <List.Item as="li">
                TPNC: {results.result.productData.tpnc}
              </List.Item>
              <List.Item as="li">
                GTIN: {results.result.productData.gtin}
              </List.Item>
              <List.Item as="li">
                Healthscore:{" "}
                {results.result.productData.productCharacteristics &&
                results.result.productData.productCharacteristics.healthScore
                  ? results.result.productData.productCharacteristics
                      .healthScore
                  : "Not available"}
              </List.Item>
            </List>
            {hfss && (
              <Message positive={!hfssStatus} negative={hfssStatus}>
                <Message.Header>HFSS</Message.Header>
                <Message.Content>
                  <List as="ul">
                    <HfssList />
                  </List>
                </Message.Content>
              </Message>
            )}
          </Grid.Column>

          {dotcomList && (
            <Grid.Column computer={10} tablet={8} mobile={16}>
              <Accordion fluid styled>
                <Accordion.Title
                  active={activeIndex === 0}
                  index={0}
                  onClick={handleAccordianIndex}
                >
                  <Icon name="dropdown" />
                  Availability dotcom store ids (
                  {results.result.stockData.availabilities.length})
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                  <StockIds
                    availabilities={results.result.stockData.availabilities}
                  />
                </Accordion.Content>
                <Accordion.Title
                  active={activeIndex === 1}
                  index={1}
                  onClick={handleAccordianIndex}
                >
                  <Icon name="dropdown" />
                  Ranging dotcom store ids ({dotcomList.length})
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 1}>
                  {countryCode === "GB" && (
                    <>
                      <RangeIdsByLocation
                        stores={dotcomList}
                        region="England"
                      />
                      <RangeIdsByLocation
                        stores={dotcomList}
                        region="Scotland"
                      />
                      <RangeIdsByLocation stores={dotcomList} region="Wales" />
                      <RangeIdsByLocation
                        stores={dotcomList}
                        region="Northern Ireland"
                      />
                    </>
                  )}
                  {countryCode === "IE" && (
                    <RangeIdsByLocation
                      stores={dotcomList}
                      region="Irish Republic"
                    />
                  )}
                </Accordion.Content>
                <Accordion.Title
                  active={activeIndex === 2}
                  index={2}
                  onClick={handleAccordianIndex}
                >
                  <Icon name="dropdown" />
                  Ranging dotcom location uuids
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 2}>
                  <RangeUuids stores={dotcomList} />
                </Accordion.Content>
                {countryCode === "GB" && (
                  <>
                    <Accordion.Title
                      active={activeIndex === 3}
                      index={3}
                      onClick={handleAccordianIndex}
                    >
                      <Icon name="dropdown" />
                      Ranging Scan-As-You-Shop store ids ({tsaysList.length})
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === 3}>
                      <RangeIdsByLocation stores={tsaysList} region="England" />
                      <RangeIdsByLocation
                        stores={tsaysList}
                        region="Scotland"
                      />
                      <RangeIdsByLocation stores={tsaysList} region="Wales" />
                      <RangeIdsByLocation
                        stores={tsaysList}
                        region="Northern Ireland"
                      />
                    </Accordion.Content>
                  </>
                )}
                {countryCode === "GB" && (
                  <>
                    <Accordion.Title
                      active={activeIndex === 4}
                      index={4}
                      onClick={handleAccordianIndex}
                    >
                      <Icon name="dropdown" />
                      Ranging Whoosh store ids ({whooshList.length})
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === 4}>
                      <RangeIdsByLocation
                        stores={whooshList}
                        region="England"
                      />
                      <RangeIdsByLocation
                        stores={whooshList}
                        region="Scotland"
                      />
                      <RangeIdsByLocation stores={whooshList} region="Wales" />
                      <RangeIdsByLocation
                        stores={whooshList}
                        region="Northern Ireland"
                      />
                    </Accordion.Content>
                  </>
                )}
                <Accordion.Title
                  active={activeIndex === 5}
                  index={5}
                  onClick={handleAccordianIndex}
                >
                  <Icon name="dropdown" />
                  Ranging all Tesco store ids ({allStoresList.length})
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 5}>
                  <RangeIds stores={allStoresList} />
                </Accordion.Content>
              </Accordion>
            </Grid.Column>
          )}
        </Grid.Row>
      )}
    </Grid>
  );
};

export default RangeResults;
